let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9NNah")).then(() => parcelRequire('byCzz'));